import React from 'react';
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from '@mui/material'

import { niceUnitDisplayer } from '../app/helpers.js'

import { selectScreenRuler } from '../app/inspection.js'

import './Scale.css'


function Scale(props) {
  const currentResolutionInMap = props.currentResolutionInMap;
  const onFitToAnnotations = props.onFitToAnnotations;
  const ruler = useSelector(selectScreenRuler)
  const scaleSize = 200
  const scaleInfos = ruler({
    pt1:[0,0],
    pt2:[scaleSize,0],
    currentResolutionInMap: currentResolutionInMap
  })

  return <div className="scale">
    {onFitToAnnotations && (
      <Tooltip title="Center view on annotations" placement="top">
        <button
          type="button"
          className="fit-annotations"
          onClick={onFitToAnnotations}
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      </Tooltip>
    )}
    <div className="size" style={{width: `${scaleSize}px`}}>{scaleInfos === undefined ? "..." : niceUnitDisplayer(scaleInfos)}</div>
    {props.children}
  </div>
}

export default Scale;